import React from 'react';
import { useSEO } from '../../hooks/useSEO';
import SectionHeading from '../../components/ui/SectionHeading';
import AnimatedSection from '../../components/ui/AnimatedSection';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Contact = () => {
  const { FiMapPin, FiPhone, FiArrowRight } = FiIcons;
  
  useSEO({
    // Length: 51 characters
    title: 'Contact Us | NYC SEO Agency | Free SEO Audit & Quote',
    description: 'Contact NewYorkCitySEO.agency to schedule a consultation and start dominating Google and AI Search in NYC today.',
  });

  return (
    <div className="pt-20 pb-24 bg-slate-950 min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <AnimatedSection>
          <SectionHeading 
            subtitle="Get In Touch" 
            title="Connect With NYC's SEO Experts" 
            description="Ready to outrank your competitors? Contact us today for a consultation on how we can improve your visibility."
          />
        </AnimatedSection>

        <div className="max-w-4xl mx-auto mt-16">
          <div className="grid md:grid-cols-2 gap-12">
            <AnimatedSection delay={0.2}>
              <div className="space-y-10">
                <div>
                  <h3 className="text-2xl font-bold text-white mb-4 text-glow">Why Partner With Us?</h3>
                  <p className="text-slate-400 leading-relaxed font-medium">
                    We are a team of dedicated NYC SEO experts who manually analyze, strategize, and execute high-end campaigns.
                  </p>
                </div>
                <div className="space-y-8">
                  <div className="flex items-start space-x-4 group">
                    <div className="w-12 h-12 bg-slate-900 rounded-full flex items-center justify-center flex-shrink-0 border border-slate-800 shadow-lg group-hover:border-blue-500/50 transition-colors">
                      <SafeIcon icon={FiMapPin} className="text-blue-500 text-xl" />
                    </div>
                    <div>
                      <h4 className="text-white font-bold">NYC Headquarters</h4>
                      <p className="text-slate-400 text-sm mt-1">
                        200 Broadway<br /> Floor 3<br /> New York, NY 10038
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </AnimatedSection>

            <AnimatedSection delay={0.4}>
              <div className="glass-panel p-8 rounded-2xl border border-slate-800 shadow-2xl h-full flex flex-col justify-center">
                <h3 className="text-2xl font-bold text-white mb-6">Start Your SEO Audit</h3>
                <a 
                  href="https://forms.crcnu.com/i/customer-inquiry" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-xl font-bold text-center transition-all shadow-[0_0_20px_rgba(37,99,235,0.3)] flex items-center justify-center space-x-3 group"
                >
                  <span>Request Free SEO Audit</span>
                  <SafeIcon icon={FiArrowRight} className="group-hover:translate-x-1 transition-transform" />
                </a>
              </div>
            </AnimatedSection>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;